module.exports = __webpack_public_path__ + "img/WOOOL_A1010.178d533b.png";